/* eslint-disable max-len */
const React = require('react');

const PluginVTEX = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="48" viewBox="0 0 54 48">
    <path fill="#F36" d="M43.146 7h-28.37c-1.026.01-1.974.562-2.5 1.457-.528.896-.558 2.006-.081 2.93l2.84 5.495H9.888c-.657-.012-1.272.33-1.615.9-.344.57-.365 1.282-.056 1.872l9.128 17.535c.328.63.971 1.023 1.672 1.023.7 0 1.344-.393 1.671-1.023l2.478-4.751 3.112 5.983c.506.971 1.499 1.579 2.58 1.579s2.074-.608 2.58-1.579l14.227-27.19c.47-.896.442-1.977-.075-2.845-.517-.868-1.446-1.395-2.445-1.386zM30.041 18.52l-6.212 12.006c-.213.415-.631.674-1.087.674-.455 0-.873-.26-1.087-.674l-6.132-11.89c-.189-.367-.178-.808.03-1.164.207-.355.58-.572.982-.572h12.547c.378-.006.731.195.928.527.197.333.209.748.03 1.092z" />
  </svg>
);

module.exports = PluginVTEX;
